import { Component } from 'react'
import { connect } from 'react-redux'
import HelpfulTopics from 'components/HelpfulTopics'
import { GroupContentHOC, NavigationHOC } from 'hocs'
import { fetchTopics } from './actions'
import { selectDeviceId } from './selectors'

class HelpfulTopicsContainer extends Component {
  componentDidMount() {
    this.props.fetchTopics(this.props.deviceId)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.deviceId !== nextProps.deviceId) {
      this.props.fetchTopics(nextProps.deviceId)
    }
  }

  render() {
    return <HelpfulTopics {...this.props} />
  }
}

const mapStateToProps = (state) => ({ deviceId: selectDeviceId(state) })

const mapDispatchToProps = (dispatch) => ({
  fetchTopics: (deviceId) => dispatch(fetchTopics.request(deviceId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  GroupContentHOC(NavigationHOC(HelpfulTopicsContainer), {
    stateName: 'helpfulTopics'
  })
)
